module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 29.266 21.949",
      url: "img/" + "sprite.svg#envelope-usage",
      toString: function () {
        return this.url;
      }
    }